import { api } from "@/config"
import { Profile, ProfileReport } from "@/types"
import { WebInputFile } from '@codeleap/types'

const BASE_URL = 'profiles/reports/'

type ReportProfileProps = {
  profileId: Profile["id"]
  description: string
  file?: WebInputFile
}

export async function reportProfile(report: ReportProfileProps) {
  const response = await api.post<ProfileReport>(BASE_URL, {
    data: {
      profile_id: report.profileId,
      description: report.description,
    },
    file: !!report?.file?.file ? report?.file?.file : null
  }, { multipart: true })

  return response.data
}